import {gql} from '@apollo/client';
import {pwaClient} from './graphql_clients';
import {OccasionBrandsQuery, OccasionsQuery} from '../gql/pwa/graphql';
import {pwaRequestHeaders} from '../support/network.ts';

const OCCASSION_FRAGMENT = gql`
    fragment Occasion on OccasionType {
        id
        brand
        model
        type
        price
        mileage
        build_year
        build_month
        cylinder_capacity
        cylinder_capacity_type
        cylinders
        weight
        weight_type
        max_towing_weight
        power
        power_type
        torque
        top_speed
        acceleration
        number_of_gears
        road_tax_min
        road_tax_max
        model_range_from
        model_range_till
        fuel_consumption_average
        fuel_consumption_city
        fuel_consumption_highway
        co2_emissions
        emission_class
        energy_label
        dealer_maintained
        date_first_issue
        date_first_admission
        maintenance_booklets
        number_of_owners
        first_owner
        fuel
        transmission
        location_id
        pictures
        description
        additional_fields
        color
        bodywork
        numberplate
        tax
        bpm
        doors
        interior
        number_of_seats
        options {
            category
            option
        }
        financing {
            url
            lease_price
            __typename
        }
        __typename
    }
`;

const OCCASIONS = gql`
    query occasions(
        $start: Int
        $limit: Int
        $brands: [String]
        $models: [String]
        $build_year_from: Int
        $build_year_till: Int
        $price_from: Int
        $price_till: Int
        $mileage_from: Int
        $mileage_till: Int
        $transmission: String
        $location_id: Int
    ) {
        occasions(
            start: $start
            limit: $limit
            brands: $brands
            models: $models
            build_year_from: $build_year_from
            build_year_till: $build_year_till
            price_from: $price_from
            price_till: $price_till
            mileage_from: $mileage_from
            mileage_till: $mileage_till
            transmission: $transmission
            location_id: $location_id
        ) {
            ...Occasion
        }
        occasionPageInfo(
            brands: $brands
            models: $models
            build_year_from: $build_year_from
            build_year_till: $build_year_till
            price_from: $price_from
            price_till: $price_till
            mileage_from: $mileage_from
            mileage_till: $mileage_till
            transmission: $transmission
            location_id: $location_id
        ) {
            count
            numberOfPages
            __typename
        }
    }

    ${OCCASSION_FRAGMENT}
`;

const OCCASION_BRANDS = gql`
    query occasionBrands {
        occasionBrands {
            name
            models
            __typename
        }
    }
`;

export class Occasions {
    static async getOccasionBrands() {
        const result = await pwaClient.query<OccasionBrandsQuery>({
            query: OCCASION_BRANDS,

            context: {
                headers: pwaRequestHeaders,
            },
        });

        return result;
    }
    static async getOccasions(
        start: number,
        limit: number,

        brands?: string[],
        models?: string[],
        buildYearFrom?: number,
        buildYearTill?: number,
        priceFrom?: number,
        priceTill?: number,
        mileageFrom?: number,
        mileageTill?: number,
        transmission?: string,
        locationId?: number,
    ) {
        const result = await pwaClient.query<OccasionsQuery>({
            query: OCCASIONS,
            variables: {
                start,
                limit,
                brands: brands,
                models: models,
                build_year_from: buildYearFrom,
                build_year_till: buildYearTill,
                price_from: priceFrom,
                price_till: priceTill,
                mileage_from: mileageFrom,
                mileage_till: mileageTill,
                transmission: transmission,
                location_id: locationId,
            },
            context: {
                headers: pwaRequestHeaders,
            },
        });

        return result;
    }

    static async getAllOccasions() {
        const result = await pwaClient.query<OccasionsQuery>({
            query: OCCASIONS,
            context: {
                headers: pwaRequestHeaders,
            },
        });

        return result;
    }
}
